import { createTheme } from "@material-ui/core/styles";
import GTWalsheimPro from "./fonts/GTWalsheimPro-Medium.woff";

export let domainTheme;
export let domain = window.location.hostname;

export const MM_THEME = createTheme({
  palette: {
    primary: {
      main: "#FFE200",
    },
    secondary: {
      contrastText: "#000000",
      main: "#000000",
      light: "#FAFCFC",
      white: "#FFFFFF",
    },
    disabled: {
      main: "#BBBDBD",
      light: "#E1E3E3",
    },
  },
  classes: {
    mainButton: {
      backgroundColor: "#FFE200",
      color: "#000000",
      padding: "8px 16px",
      width: "100%",
      height: 56,
      borderRadius: 0,
      border: "2px solid #FFE200",
      boxShadow: "none",
      "&:hover": {
        border: "2px solid #000000",
        color: "#FFFFFF !important",
        backgroundColor: "#000000",
      },
      "&:disabled": {
        border: "2px solid #E1E3E3",
        color: "#BBBDBD",
        backgroundColor: "#E1E3E3",
      },
    },
    secondaryButton: {
      backgroundColor: "#FFFFFF",
      color: "#000000 !important",
      padding: "8px 16px",
      width: "100%",
      height: 56,
      borderRadius: 0,
      border: "2px solid #000000",
      "&:hover": {
        border: "2px solid #000000",
        color: "#FFFFFF !important",
        backgroundColor: "#000000",
      },
      "&:disabled": {
        border: "2px solid #E1E3E3",
        color: "#BBBDBD !important",
      },
    },
    warningButton: {
      backgroundColor: "#FFFFFF",
      color: "#C20902 !important",
      padding: "8px 16px",
      width: "100%",
      height: 56,
      borderRadius: 0,
      border: "2px solid #C20902",
      "&:hover": {
        border: "2px solid #C20902",
        color: "#FFFFFF !important",
        backgroundColor: "#C20902",
      },
      "&:disabled": {
        border: "2px solid #E1E3E3",
        color: "#BBBDBD !important",
      },
    },
    secondaryIconButton: {
      backgroundColor: "#FFFFFF",
      color: "#000000 !important",
      padding: "8px 16px",
      height: 56,
      borderRadius: 0,
      border: "2px solid #000000",
      "&:hover": {
        border: "2px solid #000000",
        color: "#FFFFFF !important",
        backgroundColor: "#000000",
      },
      "&:disabled": {
        border: "2px solid #E1E3E3",
        color: "#BBBDBD !important",
        backgroundColor: "#E1E3E3",
      },
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": {
          fontFamily: "GTWalsheimPro",
          src: `local('GTWalsheimPro'),url(${GTWalsheimPro}) format('woff')` /* Legacy iOS */,
        },
        body: {
          fontFamily: "GTWalsheimPro,sans-serif !important",
        },
        ".localeBar": {
          backgroundColor: "#FFE200",
          height: "30px",
          paddingTop: "3px",
        },
        ".login form .MuiCardActions-root": {
          margin: 50,
        },
        ".btnSubmit": {
          backgroundColor: "#FFE200",
          borderRadius: "0px",
          color: "#000000 !important",
          "&:hover": {
            backgroundColor: "#000000",
            color: "#FFFFFF !important",
          },
          "&:disabled": {
            backgroundColor: "#E1E3E3",
            color: "#BBBDBD !important",
          },
        },
        ".layout": {
          backgroundColor: "#FFF !important",
        },
        ".login div span:nth-child(2)": {
          color: "#FFE200",
        },
        ".etiquetaUsuario": {
          display: "none",
        },
        ".MuiIconButton-colorInherit": {
          color: "#FFFFFF",
          "&:hover": {
            color: "#FFE200",
          },
        },
        ".MuiFormControl-root": {
          width: "100%",
        },
        ".MuiButton-contained": {
          backgroundColor: "#FFE200",
          borderRadius: "0px",

          color: "#000000 !important",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "#000000",
            color: "#FFFFFF !important",
          },
          "&:disabled": {
            backgroundColor: "#E1E3E3",
            color: "#BBBDBD !important",
          },
        },
        ".btnSubmit, .MuiButton-root, .RaConfirm-confirmPrimary, .MuiTypography-caption, .MuiTypography-body1, .MuiTypography-body2, .MuiMenuItem-root, .MuiButton-contained, .MuiFormLabel-root, .MuiInputBase-root, .MuiTypography-h1,.MuiTypography-h2, .MuiTypography-h3, .MuiTypography-h4, .MuiTypography-h5, .MuiTypography-h6": {
          fontFamily: "GTWalsheimPro,sans-serif !important",
          borderRadius: "0px !important",
        },
        ".ra-confirm": {
          backgroundColor: "#FFE200",
          color: "#000000 !important",
          padding: "8px 16px",
          maxWidth: 400,
          borderRadius: 0,
          "&:hover": {
            color: "#FFFFFF !important",
            backgroundColor: "#000000",
          },
        },
        ".MuiFormControl-marginNormal": {
          margin: "0 !important",
        },
        ".MuiListItemIcon-root": {
          minWidth: "36px !important",
        },
        ".MuiDataGrid-cell": {
          fontFamily: "GTWalsheimPro,sans-serif !important",
        },
        ".MuiDataGrid-iconSeparator": {
          display: "none !important",
        },
        ".MuiDataGrid-columnHeaderTitleContainer": {
          padding: "0 !important",
        },
      },
    },
  },
});
